import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Salvar", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_tipo_inscricao_estadual = _resolveComponent("selecionar-tipo-inscricao-estadual")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      width: 800,
      title: "Inscrições",
      "wrap-class-name": "ss-modal-cadastros",
      centered: ""
    }, {
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.salvarInscricoes && _ctx.salvarInscricoes(...args)))
          }, _hoisted_2)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_a_form_item, {
                  label: "Tipo IE",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_selecionar_tipo_inscricao_estadual, {
                      codigoSelecionado: _ctx.state.pessoaInscricoes.tipoIe,
                      "onUpdate:codigoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.pessoaInscricoes.tipoIe) = $event))
                    }, null, 8, ["codigoSelecionado"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_a_form_item, {
                  label: "Inscrição Estadual",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      maxlength: "14",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.pessoaInscricoes.inscricaoEstadual) = $event)),
                      disabled: (_ctx.state.pessoaInscricoes.tipoIe !== _ctx.ETipoInscricaoEstadual.ContribuinteICMS)
                    }, null, 8, _hoisted_6), [
                      [_vModelText, _ctx.state.pessoaInscricoes.inscricaoEstadual]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_a_switch, {
                  checked: _ctx.state.pessoaInscricoes.principal,
                  "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.pessoaInscricoes.principal) = $event)),
                  style: {"float":"right"},
                  "checked-children": "Principal",
                  "un-checked-children": "Outras"
                }, null, 8, ["checked"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_a_form_item, {
                  label: "Inscrição Municipal",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      maxlength: "15",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.pessoaInscricoes.inscricaoMunicipal) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.pessoaInscricoes.inscricaoMunicipal]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_a_form_item, {
                  label: "Inscrição SUFRAMA",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      maxlength: "9",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.pessoaInscricoes.inscricaoSuframa) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.pessoaInscricoes.inscricaoSuframa]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_a_form_item, {
                  label: "TARE",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      maxlength: "15",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.pessoaInscricoes.inscricaoTare) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.pessoaInscricoes.inscricaoTare]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_a_form_item, {
                  label: "ANTT",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      maxlength: "20",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.pessoaInscricoes.inscricaoAntt) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.pessoaInscricoes.inscricaoAntt]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createVNode(_component_requisicao_modal, {
              visivel: _ctx.modalBase.exibirRequisicaoModal,
              "onUpdate:visivel": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
              retornoRequisicao: _ctx.modalBase.retornoRequisicao
            }, null, 8, ["visivel", "retornoRequisicao"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}